'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Demo = _styledComponents2.default.div.withConfig({
  displayName: 'Demo'
})(['box-sizing:border-box;width:100%;background:hsla(31,15%,50%,0.1);text-align:center;border-radius:2px;padding:1em;']);

exports.default = Demo;


//////////////////
// WEBPACK FOOTER
// ./~/flexomatic/lib/components/Demo.js
// module id = 798
// module chunks = 4